// extracted by mini-css-extract-plugin
module.exports = {"btns":"Button_btns__1E8q7","btns--border":"Button_btns--border__2jfhy","btns--borderless":"Button_btns--borderless__1Wm63","ant-btn-disabled":"Button_ant-btn-disabled__1xtp2"};